import {isNil, last} from 'ramda';
import {isNotNil} from 'ramda-adjunct';

import {DrillDownStatistics} from '@dms/api/core';

import {Nullish} from 'shared/web';

import {LevelConfiguration} from '../types';

export function getFirstColumnText(
  data: DrillDownStatistics,
  levelConfiguration: LevelConfiguration | Nullish,
  translations: Record<string, string>
): string | null {
  const text = translations[last(data.levels)?.value ?? ''];

  if (isNil(text)) {
    return null;
  }

  return isNotNil(levelConfiguration) && levelConfiguration.formatter
    ? levelConfiguration.formatter(text)
    : text;
}
